import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { useCallback } from 'react'
import { AdminPortalTabBar } from '../../components/AdminPortalTabBar'

const Tab = createMaterialTopTabNavigator()

interface TabProp {
  name: string
  component: any
  title: string
  initialParams?: any
}

interface TabNavigatorProps {
  title: string
  tabs: TabProp[]
}

const TabNavigator = ({ title, tabs }: TabNavigatorProps) => {
  const tabBar = useCallback((props) => <AdminPortalTabBar {...props} />, [])
  return (
    <Box {...styles.subcontainer}>
      <Text {...styles.title}> {title}</Text>
      <Spacer direction="vertical" size={16} />
      <Tab.Navigator tabBar={tabBar} screenOptions={{ swipeEnabled: false }}>
        {tabs.map((tab: TabProp) => (
          <Tab.Screen
            name={tab.name}
            component={tab.component}
            options={{ title: tab.title }}
            initialParams={tab.initialParams}
          />
        ))}
      </Tab.Navigator>
    </Box>
  )
}

export default TabNavigator

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  subcontainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'column',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    height: '100%',
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  title: {
    fontSize: 16,
    color: 'BLUE_SHADE_PRIMARY',
    fontFamily: 'jioType-bold',
  } as TextProps,
}
